import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { APP_ROUTES } from "../constants";
import { useSessionStore } from "../store/useSessionStore";
import { isCipInReview } from "../utils/cip-review";
import { normalizeRoutePath } from "../utils/route-path";
import { useRouteWithToken } from "./useRouteWithToken";

const ALLOWED_WHILE_REVIEW = new Set<string>([
  APP_ROUTES.LOADING_PAGE,
  APP_ROUTES.CIP_REVIEW_PAGE,
  APP_ROUTES.SESSION_EXPIRED_PAGE,
  APP_ROUTES.ERROR_PAGE,
  APP_ROUTES.SUPPORT_PAGE,
]);

const KNOWN_FLOW_PATHS = new Set<string>(Object.values(APP_ROUTES));

/**
 * If the depositor is still in CIP manual review, keep them on the review
 * screen. Deep links to landing / stores / barcode bounce here.
 */
export function useCipReviewGate() {
  const { redirectTo } = useRouteWithToken();
  const location = useLocation();
  const cipStatus = useSessionStore((s) => s.session.data?.userStatus?.cipStatus);
  const pathnameRef = useRef(location.pathname);

  useEffect(() => {
    pathnameRef.current = normalizeRoutePath(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (!isCipInReview(cipStatus)) return;
    const path = pathnameRef.current;
    if (ALLOWED_WHILE_REVIEW.has(path)) return;
    // `/:linkId` is the splash entry — leave LoadingPage to route after splash.
    if (!KNOWN_FLOW_PATHS.has(path)) return;
    redirectTo(APP_ROUTES.CIP_REVIEW_PAGE, { replace: true });
  }, [cipStatus, location.pathname, redirectTo]);
}
